import { initElm } from "./index";
import { intercom } from "./intercom";

window.addEventListener("load", () => {
  fetch("/config.json")
    .then((r) => r.json())
    .then((config) => {
      const app = initElm(config);
      if (config.intercomAppId) {
        intercom(config.intercomAppId, app);
      }
    })
    .catch((e) => console.error(e));
});

/** Gestion des toggles avec l'attribut aria-expanded **/

// Fonction pour fermer tous les toggles
function closeAllAriaExpanded() {
    document.querySelectorAll('[aria-expanded]').forEach(function (element) {
        element.setAttribute('aria-expanded', 'false');
    });
}

// Gestion du click sur les boutons pour déclencher le toggle
document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[aria-expanded]');
    if (toggle) {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        closeAllAriaExpanded();
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        return;
    }

    const link = event.target.closest('a');
    if (link) {
        closeAllAriaExpanded();
        return;
    }

    const closeExpanded = event.target.closest('.close-expanded');
    if (closeExpanded) {
        closeAllAriaExpanded();
        return;
    }
});

// Fermeture automatique de tous les toggles lors de l'ouverture d'un drawer
let drawerWasOpened = false;

const drawerObserver = new MutationObserver(function () {
    const drawerOpened = document.querySelector('.drawer.opened') !== null;

    if (drawerOpened && !drawerWasOpened) {
        closeAllAriaExpanded();
    }

    drawerWasOpened = drawerOpened;
});

drawerObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
});